var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2539_2417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#A4A4A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2539_2417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00112 7.91025C8.33285 7.91025 8.61644 7.79214 8.85191 7.55592C9.08737 7.3197 9.20511 7.03573 9.20511 6.704C9.20511 6.37228 9.087 6.08869 8.85077 5.85322C8.61455 5.61775 8.33058 5.50002 7.99886 5.50002C7.66713 5.50002 7.38354 5.61813 7.14807 5.85435C6.91261 6.09058 6.79487 6.37455 6.79487 6.70627C6.79487 7.03799 6.91298 7.32159 7.14921 7.55705C7.38543 7.79252 7.6694 7.91025 8.00112 7.91025ZM7.99999 13.009C9.30426 11.8415 10.3023 10.7216 10.9942 9.64937C11.6861 8.57715 12.032 7.63804 12.032 6.83205C12.032 5.61668 11.6459 4.61753 10.8737 3.83462C10.1015 3.05171 9.14358 2.66025 7.99999 2.66025C6.8564 2.66025 5.8985 3.05171 5.12627 3.83462C4.35405 4.61753 3.96794 5.61668 3.96794 6.83205C3.96794 7.63804 4.31388 8.57715 5.00576 9.64937C5.69765 10.7216 6.69572 11.8415 7.99999 13.009ZM7.99999 14.3397C6.32222 12.8859 5.06411 11.5329 4.22564 10.2808C3.38718 9.02864 2.96796 7.87907 2.96796 6.83205C2.96796 5.29361 3.46561 4.0481 4.46091 3.09554C5.4562 2.14297 6.63589 1.66669 7.99999 1.66669C9.36409 1.66669 10.5438 2.14297 11.5391 3.09554C12.5344 4.0481 13.032 5.29361 13.032 6.83205C13.032 7.87907 12.6128 9.02864 11.7743 10.2808C10.9359 11.5329 9.67776 12.8859 7.99999 14.3397Z",
    fill: "#A4A4A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.46b7333a801d6150d4baa0a4b4187187.svg";
export { ForwardRef as ReactComponent };